export default "__VITE_ASSET__D9omb1sM__";